import "./text.scss";
function Text({
  size,
  FontSize,
  FontWight,
  children,
  color = "primary",
  position,
}) {
  return (
    <p
      className={`
        text text-${color}
       text-${position}
        text-${size}
          text-Font-${FontSize}
           text-Font-${FontWight}
           `}
    >
      {children}
    </p>
  );
}
export default Text;
